/**
 * FriendSelectorList Styles
 */

import { StyleSheet, Platform } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'
import { FRIEND_SELECTOR_DISABLED_OPACITY } from './FriendSelectorList.constants'

export const getFriendSelectorListStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      minHeight: 200,
    },
    searchInput: {
      backgroundColor: theme.gray[100],
      borderRadius: 8,
      paddingHorizontal: 12,
      paddingVertical: 10,
      marginBottom: 12,
      fontSize: 16,
      color: theme.gray[900],
    },
    list: {
      flex: 1,
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 12,
      paddingHorizontal: 12,
      marginBottom: 8,
      backgroundColor: theme.background.card,
      borderRadius: 10,
      borderWidth: 2,
      borderColor: 'transparent',
      shadowColor: theme.black,
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.1,
      shadowRadius: 3.84,
      elevation: 5,
    },
    rowSelected: {
      borderColor: theme.primary,
    },
    rowDisabled: {
      opacity: FRIEND_SELECTOR_DISABLED_OPACITY,
    },
    rowPressed: {
      opacity: 0.8,
    },
    rowHover: {
      borderColor: theme.primary,
    },
    avatarWrap: {
      marginRight: 12,
    },
    nameBlock: {
      flex: 1,
    },
    name: {
      fontSize: Platform.OS === 'web' ? 16 : 14,
      fontWeight: '600',
      color: theme.gray[900],
    },
    subtitle: {
      fontSize: 12,
      color: theme.gray[600],
      marginTop: 2,
    },
    /** Same order as friends tab card stat line: amount then coin icon */
    rowCoinsRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
      marginTop: 2,
    },
    rowCoinIcon: {
      width: 13,
      height: 13,
    },
    checkWrap: {
      width: 24,
      height: 24,
      borderRadius: 12,
      backgroundColor: theme.gray[200],
      alignItems: 'center',
      justifyContent: 'center',
    },
    checkWrapSelected: {
      backgroundColor: theme.primary,
    },
    checkText: {
      fontSize: 14,
      fontWeight: '700',
      color: theme.white,
    },
    empty: {
      paddingVertical: 24,
      alignItems: 'center',
    },
    emptyText: {
      fontSize: 14,
      color: theme.gray[600],
      textAlign: 'center',
    },
    loading: {
      paddingVertical: 24,
      alignItems: 'center',
    },
    gridWrapper: {
      flex: 1,
      width: '100%',
      minHeight: 200,
    },
    gridCardDisabled: {
      opacity: FRIEND_SELECTOR_DISABLED_OPACITY,
    },
    gridCardPressed: {
      opacity: 0.85,
    },
    gridCardHover: {
      opacity: 0.95,
    },
  })
